<template>
  <a
    v-if="ostadbankSupportPhone"
    :href="'tel:' + ostadbankSupportPhone"
    class="call-center-fixed CallButton"
  >
    <div class="call-center-fixed__icon text-xs-xs md:text-base">
      <AppIcon
        name="phone"
        size="large"
      />
    </div>
    <div class="call-center-fixed__text">
      <div class="call-center-fixed__text__label">
        <span>
          {{ $t("menu.backup_phone") }}
        </span>
      </div>
      <div class="call-center-fixed__text__number">
        <span class="text__sub--2 text-white">
          {{ ostadbankSupportPhone }}
        </span>
      </div>
    </div>
  </a>
</template>
<script>
import AppIcon from '@library/element/icon'
export default {
  name: 'CallButton',
  components: { AppIcon },
  props: {
    ostadbankSupportPhone: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss">
.call-center-fixed {
  @apply flex fixed items-center w-12 h-12 md:w-auto md:h-auto px-4 py-4 md:py-2 bottom-6 right-6 bg-green-primary text-white rounded-full z-50 shadow-lg;
  &__text {
    @apply hidden md:block md:mr-7;
    &__label {
      @apply text__sub--3;
    }
    &__number {
      @apply text__sub--2;
    }
  }
}
</style>
